module.exports = __webpack_public_path__ + "img/ring_g_l_1_1@2x.61e9bfc9.png";